<p-toast [style]="{marginTop: '41vh'}" position="top-center" key="cxctmpamortiza"></p-toast>
<p-confirmDialog [transitionOptions]="'0ms'" key="cxctmpamortizaConfirmacion" title="Confirmar Acción" appendTo="body">
</p-confirmDialog>

<div class="p-grid" style="width: 99%">
    <div class="p-col-12">
        <app-invmaebarra [botonNuevo]="btnNuevo" [botonGuardar]="btnGuardar" [botonBorrar]="btnBorrar"
            [botonRegresar]="btnRegresar" [barraBotonesCRUD]="false" [barraBotonesDesplaz]="true" [barraBotones3]="true"
            [barraBotonesAsiCon]="false" [barraBotones5]="false" [barraBotones3Alt]="false" [botonVisto]="false"
            [botongeneracuo]="true" [botonAlmacenardoc]="true" [botonBuscar]="false" [botonBinocular]="true"
            [botonreversacuo]="true" [botonverAsiento]="false" [botonAsiento]="false" (signal)="manejarSenales($event)">
        </app-invmaebarra>
    </div>

</div>
<div class="p-col-12">
    <div class="divgrups2" style="margin-top: -10px; margin-bottom: -10px; width: 99%">
        <div class="p-col-12">
            <div class="p-grid" style="margin-top: -10px; margin-bottom: -10px;">
                <div class="p-col-10"></div>
                <!-- <div class="p-col-2">
                    <input type="text" pInputText style="background-color: deepskyblue"
                        [(ngModel)]="venDevFacService.encdevfacarray[indicador].ENCDVF_GRUPO" [disabled]="true">
                </div>
                <div class="p-col-1"></div>
                <div class="p-col-2">
                    <input type="text" pInputText style="background-color: deepskyblue"
                        [(ngModel)]="venDevFacService.encdevfacarray[indicador].ENCDVF_ESTADO" [disabled]="true">
                </div>
                <div class="p-col-1">
                    <input type="text" pInputText
                        style="background-color: darkblue; font-weight: bold; color: white;"
                        [(ngModel)]="venDevFacService.encdevfacarray[indicador].ENCDVF_ESTADO_FE" [disabled]="true">
                </div>
                <div class="p-col-2">
                    <input type="text" pInputText
                        style="background-color: darkblue; font-weight: bold; color: white;"
                        [(ngModel)]="venDevFacService.encdevfacarray[indicador].ENCDVF_AUTORIZACION_FE"
                        [disabled]="true">
                </div>
                <div class="p-col-2">
                    <input type="text" pInputText
                        style="background-color: darkblue; font-weight: bold; color: white;"
                        [(ngModel)]="venDevFacService.encdevfacarray[indicador].ENCDVF_CLAVEACCESO_FE"
                        [disabled]="true">
                </div> -->
                <div class="p-col-2">
                    <input type="text" pInputText style="background-color: deepskyblue;"
                        [(ngModel)]="cxctmpamortizacionService.enctmpamortiza[indicador].ASI_NRO" [disabled]="true">
                </div>
            </div>
        </div>
    </div>
</div>
<p-tabView [(activeIndex)]="index" (onChange)="changeTabs()" [style]="{'width':'98%'}">
    <p-tabPanel header="General">
        <p-scrollPanel [style]="{'width':'100%', 'height':'calc(100vh - 270px)'}">
            <div class="contorno" id="contorno">
                <div class="divgrups">
                    <div class="p-grid">
                        <!--LINEA 1-->
                        <div class="p-col-1">
                            <span>Num Doc.:</span>
                        </div>
                        <div class="p-col-2">
                            <label for="ENCCUOTA_CODIGO"></label>
                            <input class="frm" id="ENCCUOTA_CODIGO" type="text" pInputText disabled
                                [(ngModel)]="cxctmpamortizacionService.enctmpamortiza[indicador].ENCCUOTA_CODIGO"
                                (keydown.enter)="setFocus($event)" (keydown)="botonesmodificar()" autocomplete="off">
                        </div>
                        <div class="p-col-12" style="margin-top: -5px">
                            <div class="p-grid">
                                <div class="p-col-1">
                                    <span>Factura:</span>
                                </div>
                                <div class="p-col-2">

                                    <label for="ENCFAC_NUMERO"></label>
                                    <input class="frm" id="ENCFAC_NUMERO" type="text" pInputText [disabled]="boolfac"
                                        [(ngModel)]="cxctmpamortizacionService.enctmpamortiza[indicador].ENCFAC_NUMERO"
                                        (keydown.enter)="setFocus($event)" (keydown)="botonesmodificar()"
                                        autocomplete="off">
                                </div>
                                <div class="p-col-1">
                                    <div class="p-grid">
                                        <div class="p-col-5">
                                            <button type="button" [disabled]="boolfac"
                                                style="background-image: url(../../../assets/images/iconos/buscar.webp);"
                                                (click)="busqueFactura(cxctmpamortizacionService.enctmpamortiza[indicador].ENCFAC_NUMERO)"></button>
                                        </div>

                                    </div>

                                </div>
                                <div class="p-col-1"></div>
                                <div class="p-col-1">
                                    <span class="obligatorio"> Cliente:</span>
                                </div>
                                <div class="p-col-1">
                                    <label for="CLI_CODIGO"></label>
                                    <input class="frm" id="CLI_CODIGO" type="text" pInputText disabled
                                        [(ngModel)]="cxctmpamortizacionService.enctmpamortiza[indicador].CLI_CODIGO"
                                        (keydown.enter)="setFocus($event)" (keydown)="botonesmodificar()"
                                        autocomplete="off">
                                </div>
                                <div class="p-col-1">
                                    <span>Nombre:</span>
                                </div>
                                <div class="p-col-2">
                                    <label for="lblclinombre"></label>
                                    <input class="frm" id="lblclinombre" type="text" pInputText disabled
                                        style="color: blue;" [(ngModel)]="lblclinombre" autocomplete="off">
                                </div>

                                <div class="p-col-1">
                                    <span>Teléfono:</span>
                                </div>
                                <div class="p-col-1">
                                    <label for="CLI_TELEFONO1"></label>
                                    <input class="frm" id="CLI_TELEFONO1" type="text" pInputText disabled
                                        [(ngModel)]="cxctmpamortizacionService.enctmpamortiza[indicador].CLI_TELEFONO1"
                                        (keydown.enter)="setFocus($event)" (keydown)="botonesmodificar()"
                                        autocomplete="off">
                                </div>
                                <!-- <div class="p-col-1">
                                    <span>Cliente:</span>
                                </div> -->
                                <!-- <div class="p-col-2">
                                    <label for="CLI_CODIGO"></label>
                                    <input class="frm" id="CLI_CODIGO" type="text" pInputText disabled
                                        [(ngModel)]="cxctmpamortizacionService.enctmpamortiza[indicador].CLI_CODIGO"
                                        (keydown.enter)="setFocus($event)" (keydown)="botonesmodificar()"
                                        autocomplete="off">
                                </div>
                                <div class="p-col-2">
                                    <label for="lblclinombre"></label>
                                    <input class="frm" id="lblclinombre" type="text" pInputText disabled
                                        style="color: blue;"
                                        [(ngModel)]="lblclinombre"
                                        autocomplete="off">
                                </div> -->
                            </div>
                        </div>


                        <!--LINEA 2-->
                        <div class="p-col-12" style="margin-top: -15px">
                            <div class="p-grid">
                                <div class="p-col-1">
                                    <span>Valor Financiado Original:</span>
                                </div>
                                <div class="p-col-1">
                                    <label for="CAPITAL"></label>
                                    <input class="frm" id="CAPITAL" type="text" pInputText disabled oninput="this.value= this.value.
                                    replace(/[^0-9.]/g, '')
                                    .replace(/^\./g,'0.')
                                    .replace(/(\..*)\./g,'$1')
                                    .replace(/^(\d+)(\.\d{0,2})?.*$/, '$1$2');"
                                        [(ngModel)]="cxctmpamortizacionService.enctmpamortiza[indicador].CAPITAL"
                                        (keydown.enter)="setFocus($event)" (keydown)="botonesmodificar()"
                                        autocomplete="off">
                                </div>
                                <div class="p-col-1"></div>
                                <div class="p-col-1">
                                    <div class="p-grid">
                                        <div class="p-col-5"></div>
                                        <div class="p-col-7">
                                            <span>Tasa Anual:</span>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="p-col-1">
                                    <span>Tasa Anual:</span>
                                </div> -->
                                <div class="p-col-1">
                                    <label for="TASA"></label>
                                    <input class="frm" id="TASA" type="text" pInputText oninput="this.value= this.value.
                                    replace(/[^0-9.]/g, '')
                                    .replace(/^\./g,'0.')
                                    .replace(/(\..*)\./g,'$1')
                                    .replace(/^(\d+)(\.\d{0,2})?.*$/, '$1$2');"
                                        [(ngModel)]="cxctmpamortizacionService.enctmpamortiza[indicador].TASA"
                                        (keydown.enter)="setFocus($event)" (keydown)="botonesmodificar()"
                                        autocomplete="off">
                                </div>
                                <!-- <div class="p-col-1">
                                    <span>Cedula:</span>
                                </div> -->

                            </div>
                        </div>
                        <!--LINEA 3-->
                        <div class="p-col-12" style="margin-top: -10px">
                            <div class="p-grid">
                                <div class="p-col-1">
                                    <span>Cuota Mensual:</span>
                                </div>
                                <div class="p-col-1">
                                    <label for="CUOTA_MENSUAL"></label>
                                    <input class="frm" id="CUOTA_MENSUAL" type="text" pInputText disabled
                                        [(ngModel)]="cxctmpamortizacionService.enctmpamortiza[indicador].CUOTA_MENSUAL"
                                        (keydown.enter)="setFocus($event)" (keydown)="botonesmodificar()"
                                        autocomplete="off">
                                </div>
                                <div class="p-col-1"></div>
                                <div class="p-col-1">
                                    <div class="p-grid">
                                        <div class="p-col-4"></div>
                                        <div class="p-col-8">
                                            <span> Plazo Original:</span>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="p-col-1">
                                    <span> Plazo Original:</span>
                                </div> -->
                                <div class="p-col-1">
                                    <label for="PLAZO"></label>
                                    <input class="frm" id="PLAZO" type="text" pInputText
                                        oninput="this.value= this.value.replace(/[^0-9]/g, '');"
                                        [(ngModel)]="cxctmpamortizacionService.enctmpamortiza[indicador].PLAZO"
                                        (keydown.enter)="setFocus($event)" (keydown)="botonesmodificar()"
                                        autocomplete="off">
                                </div>
                                <div class="p-col-1">

                                    <div class="p-grid">
                                        <div class="p-col-6">
                                            <span class="obligatorio"> Garante:</span>
                                        </div>
                                        <div class="p-col-5">
                                            <button type="button"
                                                style="background-image: url(../../../assets/images/iconos/buscar.webp);"
                                                (click)="busqueGarante(cxctmpamortizacionService.enctmpamortiza[indicador].GAR_ID)"></button>
                                        </div>

                                    </div>
                                </div>
                                <div class="p-col-1">
                                    <label for="GAR_ID"></label>
                                    <input class="frm" id="GAR_ID" type="text" pInputText
                                        [(ngModel)]="cxctmpamortizacionService.enctmpamortiza[indicador].GAR_ID"
                                        (keydown.enter)="setFocus($event)" (keydown)="botonesmodificar()"
                                        autocomplete="off">
                                </div>
                                <div class="p-col-1">
                                    <span>Nombre:</span>
                                </div>
                                <div class="p-col-2">
                                    <label for="lblgarnombre"></label>
                                    <input class="frm" id="lblgarnombre" type="text" pInputText disabled
                                        style="color: blue;" [(ngModel)]="lblgarnombre" autocomplete="off">
                                </div>

                                <div class="p-col-1">
                                    <span>Teléfono:</span>
                                </div>
                                <div class="p-col-1">
                                    <label for="GAR_TELEFONO1"></label>
                                    <input class="frm" id="GAR_TELEFONO1" type="text" pInputText disabled
                                        [(ngModel)]="cxctmpamortizacionService.enctmpamortiza[indicador].GAR_TELEFONO1"
                                        (keydown.enter)="setFocus($event)" (keydown)="botonesmodificar()"
                                        autocomplete="off">
                                </div>
                            </div>
                        </div>
                        <!--LINEA 4-->
                        <div class="p-col-12" style="margin-top: -10px">
                            <div class="p-grid">
                                <div class="p-col-1">
                                    <span>Dias de Gracia:</span>
                                </div>
                                <div class="p-col-1">
                                    <label for="DIA_GRA"></label>
                                    <input class="frm" id="DIA_GRA" type="text" pInputText
                                        oninput="this.value= this.value.replace(/[^0-9]/g, '');"
                                        [(ngModel)]="cxctmpamortizacionService.enctmpamortiza[indicador].DIA_GRA"
                                        (keydown.enter)="setFocus($event)" (keydown)="botonesmodificar()"
                                        autocomplete="off">
                                </div>
                                <div class="p-col-1"></div>
                                <div class="p-col-1">
                                    <div class="p-grid">
                                        <div class="p-col-5"></div>
                                        <div class="p-col-7">
                                            <span>Fecha:</span>
                                        </div>
                                    </div>
                                </div>

                                <!-- <div class="p-col-1">
                                    <span>Fecha:</span>
                                </div> -->
                                <div class="p-col-1">
                                    <p-calendar id="FECINI" [inputStyle]="{width: '100%', height: '20px'}"
                                        [(ngModel)]="cxctmpamortizacionService.enctmpamortiza[indicador].FECINI"
                                        [readonlyInput]="false" dateFormat="dd/mm/yy" (keydown.enter)="setFocus($event)"
                                        (keydown)="botonesmodificar()">
                                    </p-calendar>
                                </div>
                                <div class="p-col-2">

                                    <div class="p-grid">
                                        <div class="p-col-6">
                                            <span > Num. Doc. Origen:</span>
                                        </div>
                                        <div class="p-col-6">
                                            <input class="frm" id="ENCCUOTA_CUOORIGEN" type="text" pInputText disabled
                                        [(ngModel)]="cxctmpamortizacionService.enctmpamortiza[indicador].ENCCUOTA_CUOORIGEN"
                                        (keydown.enter)="setFocus($event)" (keydown)="botonesmodificar()"
                                        >
                                        </div>

                                    </div>
                                </div>
                                <div class="p-col-1">
                                    <span>Estado:</span>
                                </div>
                                <div class="p-col-1">
                                    <input class="frm" id="lblestado" type="text" pInputText disabled
                                [(ngModel)]="lblestado"
                                (keydown.enter)="setFocus($event)" (keydown)="botonesmodificar()"
                                >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <app-aggridsaci [width]="" [height]="80" [enableSorting]="false" [enableFilter]="true"
                [rowData]="cxctmpamortizacionService.dettmpamortiza" [frameworkComponents]="frameworkComponents"
                [animateRows]="true" [rowSelection]="rowSelection" [columnDefs]="columnDefsCxctmpamortiza"
                [defaultColDef]="defaultCxctmpamortiza" [rowStyle]="rowStyle" [singleClickEdit]="false"
                [botones]="false" [mostrarGuardar]="false" [botonesAdicionales]="false" [comboOpciones]=""
                (selected)="seleccionItem($event)" [tipodetalle]="" [botonBorrar]="true" (cambios)="cambio($event)">
            </app-aggridsaci>

        </p-scrollPanel>
    </p-tabPanel>
</p-tabView>

<p-dialog header="Busqueda de Datos" [(visible)]="displayDialogBusquedaFast" [transitionOptions]="'0ms'" [modal]="false"
    [style]="{width: '70vw', height: '70vh'} ">
    <app-busquedadlg [arrayOptions]="types" [arregloConsulta]="arregloCons" [tabla]="tabla"
        [busquedaParams]="busquedacampos" [consulta]="consulta" [where]="where"
        (opcionSeleccionada)="manejarSeleccion($event)"></app-busquedadlg>
</p-dialog>

<div style="position: fixed;
			z-index: 999;
			height: 2em;
			width: 2em;
			overflow: visible;
			margin: auto;
			top: 0;
			left: 0;
			bottom: 0;
			right: 0;">
    <p-progressSpinner *ngIf="spin" [style]="{width: '100px', height: '100px'}" animationDuration=".5s">
    </p-progressSpinner>
    <p-dialog [(visible)]="spin" [transitionOptions]="'0ms'" [modal]="true" [closable]="false"
        [style]="{ opacity: 0.00}" position="top">
    </p-dialog>
</div>

<p-dialog header="Documentos" [(visible)]="displayDialogDocumentos" [transitionOptions]="'0ms'" [modal]="true"
    appendTo="body" [style]="{width: '50vw', height: 'auto'}">
    <app-uploadfiles *ngIf="displayDialogDocumentos" [txtOrigen]="'CXCAMORTIZACION'"
        [txtNumComprobante]="cxctmpamortizacionService.enctmpamortiza[indicador].ENCCUOTA_CODIGO"
        [boolpercont]="false"
        (signalSalir)="recibirSenalesDocumentos($event)">

    </app-uploadfiles>
</p-dialog>

<p-dialog header="Reportes" [(visible)]="displayDialogReportes" [transitionOptions]="'0ms'" [modal]="true"
    appendTo="body" [style]="{width: '40vw', height: '400px'}">
    <app-sacimaecfngimpr [auxiliar]="auxreporte" [strNombreForma]="strNombreForma"
        [strNumDoc]="cxctmpamortizacionService.enctmpamortiza[indicador].ENCCUOTA_CODIGO" [strCampo]="'ENCCUOTA_CODIGO'"
        [botonExcel]="true" (cerrar)="cerrarReportes()"></app-sacimaecfngimpr>
</p-dialog>
<p-dialog header="Asiento Contable" [(visible)]="displayAsiContable" [transitionOptions]="'0ms'" [modal]="true"
    appendTo="body" [style]="{width:'90vw', height:'120vh'}" [draggable]="false">
    <app-conencasil *ngIf="displayAsiContable" [NumAsientoBan]="asiento" [abiertoDesde]="'cxctmpamortiza'"
        (signalSalir)="recibirSenalesConEncasil($event)"></app-conencasil>
</p-dialog>

<p-dialog header="Refinanciamiento" [(visible)]="displayrefi" [transitionOptions]="'0ms'" [modal]="true" appendTo="body"
    [style]="{width: '60vw', height: '800px'}">
    <p-toast [style]="{marginTop: '41vh'}" position="top-center" key="reifinancia"></p-toast>
    <div class="p-grid" style="width: 98%;">
        <div class="p-col-12">
            <!-- <app-invmaebarra [barraBotonesDesplaz]="true" [barraBotones3]="true" [barraBotonesAsiCon]="true"
						 [barraBotones5]="true" [botonVisto]="false" [barraBotonesCRUD]="true" [barraBotones3Alt]="false"
						 (signal)="manejarSenales($event)"
						 style="text-align: left;">
		</app-invmaebarra> -->
            <app-invmaebarra [barraBotonesDesplaz]="true" [barraBotones3]="true" [barraBotonesAsiCon]="true"
                [barraBotones5]="true"  [barraBotonesCRUD]="true" [barraBotones3Alt]="false"
                (signal)="manejarSenales2($event)" style="text-align: left;">
            </app-invmaebarra>
        </div>
        <div class="p-grid general" style="width: 99%; margin-top: -20px">
            <div class="p-col-12"></div>
            <div class="p-col-12">
                <div class="divgrups">
                    <div class="p-grid">
                        <div class="p-col-12">
                            <div class="p-grid">
                                <div class="p-col-1">
                                </div>
                                <div class="p-col-3">
                                    <div class="p-grid">
                                        <div class="p-col-1">
                                        </div>
                                        <div class="p-col-5">
                                            <span>N. Nominal:</span>
                                        </div>
                                        <div class="p-col-1"></div>
                                        <div class="p-col-5">
                                            <input class="frm" id="N_NOMINAL" type="text" pInputText disabled
                                            [(ngModel)]="dettmpamortizaSelected.N_NOMINAL"
                                            (keydown.enter)="setFocus($event)" (keydown)="botonesmodificar()"
                                            autocomplete="off">
                                        </div>
                                        
                                    </div>
                                </div>
                                <div class="p-col-8"></div>
                            </div>
                        </div>
                        <div class="p-col-12" style="margin-top: -20px">
                            <div class="p-grid">
                                <div class="p-col-1">
                                </div>
                                <div class="p-col-3">
                                    <div class="p-grid">
                                        <div class="p-col-1">
                                        </div>
                                        <div class="p-col-6">
                                            <span>Saldo Capital:</span>
                                        </div>
                                        
                                        <div class="p-col-5">
                                            <input class="frm" id="SALDO_CAPITAL" type="text" pInputText disabled
                                            [(ngModel)]="dettmpamortizaSelected.SALDO_CAPITAL"
                                            (keydown.enter)="setFocus($event)" (keydown)="botonesmodificar()"
                                            autocomplete="off">
                                        </div>
                                    </div>
                                </div>
                                <div class="p-col-8">
                                    <div class="p-grid">
                                        <div class="p-col-4"></div>
                                        <div class="p-col-4">
                                            <button class="aceptar" pButton (click)="refinanciar()"
                                                style="background-image: url(../../../assets/images/iconos/btnAceptar.webp); line-height: 2.5em; font-family: Arial, serif; margin-top: -5px; margin-left: 25px">
                                                Aceptar
                                            </button>
                                        </div>
                                        <div class="p-col-4"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="p-col-12" style="margin-top: -20px; margin-bottom: -20px">
                            <div class="p-grid">
                                <div class="p-col-1">
                                </div>
                                <div class="p-col-3">
                                    <div class="p-grid">
                                        <div class="p-col-1">
                                        </div>
                                        <div class="p-col-5">
                                            <span>Valor:</span>
                                        </div>
                                        <div class="p-col-1"></div>
                                        <div class="p-col-5">
                                            <input class="frm" id="abonocapital" type="text" pInputText 
                                            [(ngModel)]="abonocapital"
                                            oninput="this.value= this.value.
                                    replace(/[^0-9.]/g, '')
                                    .replace(/^\./g,'0.')
                                    .replace(/(\..*)\./g,'$1')
                                    .replace(/^(\d+)(\.\d{0,2})?.*$/, '$1$2');"
                                            (keydown.enter)="setFocus($event)" (keydown)="botonesmodificar()"
                                            autocomplete="off">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</p-dialog>